import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Handle} from "./Handle";
import {stores} from "../../stores";
import {observer} from "mobx-react-lite";

export const SortableItem = observer((props) => {

    function setName(index, name) {
        stores.memory.setPresetName(name, index);
    }

    function saveChange(index, name) {
        if (stores.memory.isPresetParamDirty("NAME", index)) {
            stores.midi.savePreset(index);
        }
    }

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        // transition,
        isDragging
    } = useSortable({id: props.id});

    const style = {
        transform: props.ctrlKeyPressed ? null : CSS.Transform.toString(transform),
        // transition,
        opacity: isDragging ? 0.5 : 1
        // backgroundColor: isDragging ? '#ddddff' : 'inherit'
    };

    const presetNum = props.presetNumber;

    return (
        <div ref={setNodeRef} className={`preset-selector ${props.srcElement ? 'src-elem' : ''} ${props.overed ? 'overed' : ''}`}
             key={presetNum} style={style} {...attributes} tabIndex="-1">
            <input type="text" value={stores.memory.getPresetName(presetNum)}
                   onChange={e => setName(presetNum, e.currentTarget.value)}
                   onBlur={e => saveChange(presetNum, e.currentTarget.value)}/>
            <div className="handle-wrapper" {...listeners} tabIndex="-1">
                <Handle />
            </div>
        </div>
    );

});
